 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ATTACKONPEARLHARBOR_FRONTCOVER from '@/components/AttackonPearlHarbor_frontcover'
 import LOVE_1 from '@/components/love_1'
 import ATTACKONPEARLHARBOR_TITLE from '@/components/AttackonPearlHarbor_title'
 import ATTACKONPEARLHARBOR_COPYRIGHT from '@/components/AttackonPearlHarbor_copyright'
 import ATTACKONPEARLHARBOR_TOC from '@/components/AttackonPearlHarbor_toc'
 import ATTACKONPEARLHARBOR_CHARTSANDDIAGRAMS from '@/components/AttackonPearlHarbor_chartsanddiagrams'
 import ATTACKONPEARLHARBOR_INTRODUCTION from '@/components/AttackonPearlHarbor_introduction'
 import ATTACKONPEARLHARBOR_INTRODUCTION1 from '@/components/AttackonPearlHarbor_introduction1'
 import ATTACKONPEARLHARBOR_CH1 from '@/components/AttackonPearlHarbor_ch1'
 import ATTACKONPEARLHARBOR_CH101 from '@/components/AttackonPearlHarbor_ch101'
 import ATTACKONPEARLHARBOR_CH102 from '@/components/AttackonPearlHarbor_ch102'
 import ATTACKONPEARLHARBOR_CH103 from '@/components/AttackonPearlHarbor_ch103'
 import ATTACKONPEARLHARBOR_CH104 from '@/components/AttackonPearlHarbor_ch104'
 import ATTACKONPEARLHARBOR_CH2 from '@/components/AttackonPearlHarbor_ch2'
 import ATTACKONPEARLHARBOR_CH201 from '@/components/AttackonPearlHarbor_ch201'
 import ATTACKONPEARLHARBOR_CH202 from '@/components/AttackonPearlHarbor_ch202'
 import ATTACKONPEARLHARBOR_CH203 from '@/components/AttackonPearlHarbor_ch203'
 import ATTACKONPEARLHARBOR_CH204 from '@/components/AttackonPearlHarbor_ch204'
 import ATTACKONPEARLHARBOR_CH205 from '@/components/AttackonPearlHarbor_ch205'
 import ATTACKONPEARLHARBOR_CH3 from '@/components/AttackonPearlHarbor_ch3'
 import ATTACKONPEARLHARBOR_CH4 from '@/components/AttackonPearlHarbor_ch4'
 import ATTACKONPEARLHARBOR_CH401 from '@/components/AttackonPearlHarbor_ch401'
 import ATTACKONPEARLHARBOR_CH402 from '@/components/AttackonPearlHarbor_ch402'
 import ATTACKONPEARLHARBOR_CH403 from '@/components/AttackonPearlHarbor_ch403'
 import ATTACKONPEARLHARBOR_CH404 from '@/components/AttackonPearlHarbor_ch404'
 import ATTACKONPEARLHARBOR_CH405 from '@/components/AttackonPearlHarbor_ch405'
 import ATTACKONPEARLHARBOR_CH406 from '@/components/AttackonPearlHarbor_ch406'
 import ATTACKONPEARLHARBOR_CH407 from '@/components/AttackonPearlHarbor_ch407'
 import ATTACKONPEARLHARBOR_CH408 from '@/components/AttackonPearlHarbor_ch408'
 import ATTACKONPEARLHARBOR_CH5 from '@/components/AttackonPearlHarbor_ch5'
 import ATTACKONPEARLHARBOR_CH501 from '@/components/AttackonPearlHarbor_ch501'
 import ATTACKONPEARLHARBOR_CH6 from '@/components/AttackonPearlHarbor_ch6'
 import ATTACKONPEARLHARBOR_CH7 from '@/components/AttackonPearlHarbor_ch7'
 import ATTACKONPEARLHARBOR_CH701 from '@/components/AttackonPearlHarbor_ch701'
 import ATTACKONPEARLHARBOR_CH702 from '@/components/AttackonPearlHarbor_ch702'
 import ATTACKONPEARLHARBOR_CH703 from '@/components/AttackonPearlHarbor_ch703'
 import ATTACKONPEARLHARBOR_CH704 from '@/components/AttackonPearlHarbor_ch704'
 import ATTACKONPEARLHARBOR_CH705 from '@/components/AttackonPearlHarbor_ch705'
 import ATTACKONPEARLHARBOR_CH706 from '@/components/AttackonPearlHarbor_ch706'
 import ATTACKONPEARLHARBOR_CH707 from '@/components/AttackonPearlHarbor_ch707'
 import ATTACKONPEARLHARBOR_CH708 from '@/components/AttackonPearlHarbor_ch708'
 import ATTACKONPEARLHARBOR_CH709 from '@/components/AttackonPearlHarbor_ch709'
 import ATTACKONPEARLHARBOR_CH8 from '@/components/AttackonPearlHarbor_ch8'
 import ATTACKONPEARLHARBOR_CH801 from '@/components/AttackonPearlHarbor_ch801'
 import ATTACKONPEARLHARBOR_CH802 from '@/components/AttackonPearlHarbor_ch802'
 import ATTACKONPEARLHARBOR_CH803 from '@/components/AttackonPearlHarbor_ch803'
 import ATTACKONPEARLHARBOR_CH804 from '@/components/AttackonPearlHarbor_ch804'
 import ATTACKONPEARLHARBOR_CH805 from '@/components/AttackonPearlHarbor_ch805'
 import ATTACKONPEARLHARBOR_CH806 from '@/components/AttackonPearlHarbor_ch806'
 import ATTACKONPEARLHARBOR_CH807 from '@/components/AttackonPearlHarbor_ch807'
 import ATTACKONPEARLHARBOR_CH808 from '@/components/AttackonPearlHarbor_ch808'
 import ATTACKONPEARLHARBOR_CH809 from '@/components/AttackonPearlHarbor_ch809'
 import ATTACKONPEARLHARBOR_CH810 from '@/components/AttackonPearlHarbor_ch810'
 import ATTACKONPEARLHARBOR_CH811 from '@/components/AttackonPearlHarbor_ch811'
 import ATTACKONPEARLHARBOR_CH812 from '@/components/AttackonPearlHarbor_ch812'
 import ATTACKONPEARLHARBOR_CH813 from '@/components/AttackonPearlHarbor_ch813'
 import ATTACKONPEARLHARBOR_CH814 from '@/components/AttackonPearlHarbor_ch814'
 import ATTACKONPEARLHARBOR_CH815 from '@/components/AttackonPearlHarbor_ch815'
 import ATTACKONPEARLHARBOR_CH816 from '@/components/AttackonPearlHarbor_ch816'
 import ATTACKONPEARLHARBOR_CH817 from '@/components/AttackonPearlHarbor_ch817'
 import ATTACKONPEARLHARBOR_CH818 from '@/components/AttackonPearlHarbor_ch818'
 import ATTACKONPEARLHARBOR_CH819 from '@/components/AttackonPearlHarbor_ch819'
 import ATTACKONPEARLHARBOR_CH820 from '@/components/AttackonPearlHarbor_ch820'
 import ATTACKONPEARLHARBOR_CH821 from '@/components/AttackonPearlHarbor_ch821'
 import ATTACKONPEARLHARBOR_CH822 from '@/components/AttackonPearlHarbor_ch822'
 import ATTACKONPEARLHARBOR_CH823 from '@/components/AttackonPearlHarbor_ch823'
 import ATTACKONPEARLHARBOR_CH824 from '@/components/AttackonPearlHarbor_ch824'
 import ATTACKONPEARLHARBOR_CH825 from '@/components/AttackonPearlHarbor_ch825'
 import ATTACKONPEARLHARBOR_CH826 from '@/components/AttackonPearlHarbor_ch826'
 import ATTACKONPEARLHARBOR_CH827 from '@/components/AttackonPearlHarbor_ch827'
 import ATTACKONPEARLHARBOR_CH828 from '@/components/AttackonPearlHarbor_ch828'
 import ATTACKONPEARLHARBOR_CH829 from '@/components/AttackonPearlHarbor_ch829'
 import ATTACKONPEARLHARBOR_CH830 from '@/components/AttackonPearlHarbor_ch830'
 import ATTACKONPEARLHARBOR_CH831 from '@/components/AttackonPearlHarbor_ch831'
 import ATTACKONPEARLHARBOR_CH832 from '@/components/AttackonPearlHarbor_ch832'
 import ATTACKONPEARLHARBOR_CH833 from '@/components/AttackonPearlHarbor_ch833'
 import ATTACKONPEARLHARBOR_CH834 from '@/components/AttackonPearlHarbor_ch834'
 import ATTACKONPEARLHARBOR_CH835 from '@/components/AttackonPearlHarbor_ch835'
 import ATTACKONPEARLHARBOR_CH836 from '@/components/AttackonPearlHarbor_ch836'
 import ATTACKONPEARLHARBOR_CH837 from '@/components/AttackonPearlHarbor_ch837'
 import ATTACKONPEARLHARBOR_CH838 from '@/components/AttackonPearlHarbor_ch838'
 import ATTACKONPEARLHARBOR_CH839 from '@/components/AttackonPearlHarbor_ch839'
 import ATTACKONPEARLHARBOR_CH9 from '@/components/AttackonPearlHarbor_ch9'
 import ATTACKONPEARLHARBOR_CH10 from '@/components/AttackonPearlHarbor_ch10'
 import ATTACKONPEARLHARBOR_CH1001 from '@/components/AttackonPearlHarbor_ch1001'
 import ATTACKONPEARLHARBOR_CH11 from '@/components/AttackonPearlHarbor_ch11'
 import ATTACKONPEARLHARBOR_CH1101 from '@/components/AttackonPearlHarbor_ch1101'
 import ATTACKONPEARLHARBOR_CH1102 from '@/components/AttackonPearlHarbor_ch1102'
 import ATTACKONPEARLHARBOR_CH12 from '@/components/AttackonPearlHarbor_ch12'
 import ATTACKONPEARLHARBOR_CH13 from '@/components/AttackonPearlHarbor_ch13'
 import LOVE_2 from '@/components/love_2'
 import ATTACKONPEARLHARBOR_APPENDIXI from '@/components/AttackonPearlHarbor_appendixI'
 import ATTACKONPEARLHARBOR_APPENDIXII from '@/components/AttackonPearlHarbor_appendixII'
 import ATTACKONPEARLHARBOR_APPENDIXIII from '@/components/AttackonPearlHarbor_appendixIII'
 import ATTACKONPEARLHARBOR_APPENDIXIV from '@/components/AttackonPearlHarbor_appendixIV'
 import ATTACKONPEARLHARBOR_APPENDIXV from '@/components/AttackonPearlHarbor_appendixV'
 import ATTACKONPEARLHARBOR_BIBLIOGRAPHY from '@/components/AttackonPearlHarbor_bibliography'
 import ATTACKONPEARLHARBOR_ENDNOTES from '@/components/AttackonPearlHarbor_endnotes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/AttackonPearlHarbor_frontcover",
 			"name" : "AttackonPearlHarbor_frontcover",
 			"component" : ATTACKONPEARLHARBOR_FRONTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/AttackonPearlHarbor_title",
 			"name" : "AttackonPearlHarbor_title",
 			"component" : ATTACKONPEARLHARBOR_TITLE
 		},
 		{
 			"path" : "/AttackonPearlHarbor_copyright",
 			"name" : "AttackonPearlHarbor_copyright",
 			"component" : ATTACKONPEARLHARBOR_COPYRIGHT
 		},
 		{
 			"path" : "/AttackonPearlHarbor_toc",
 			"name" : "AttackonPearlHarbor_toc",
 			"component" : ATTACKONPEARLHARBOR_TOC
 		},
 		{
 			"path" : "/AttackonPearlHarbor_chartsanddiagrams",
 			"name" : "AttackonPearlHarbor_chartsanddiagrams",
 			"component" : ATTACKONPEARLHARBOR_CHARTSANDDIAGRAMS
 		},
 		{
 			"path" : "/AttackonPearlHarbor_introduction",
 			"name" : "AttackonPearlHarbor_introduction",
 			"component" : ATTACKONPEARLHARBOR_INTRODUCTION
 		},
 		{
 			"path" : "/AttackonPearlHarbor_introduction1",
 			"name" : "AttackonPearlHarbor_introduction1",
 			"component" : ATTACKONPEARLHARBOR_INTRODUCTION1
 		},
 		{
 			"path" : "/AttackonPearlHarbor_ch1",
 			"name" : "AttackonPearlHarbor_ch1",
 			"component" : ATTACKONPEARLHARBOR_CH1
 		},
 		{
 			"path" : "/AttackonPearlHarbor_ch101",
 			"name" : "AttackonPearlHarbor_ch101",
 			"component" : ATTACKONPEARLHARBOR_CH101
 		},
 		{
 			"path" : "/AttackonPearlHarbor_ch102",
 			"name" : "AttackonPearlHarbor_ch102",
 			"component" : ATTACKONPEARLHARBOR_CH102
 		},
 		{
 			"path" : "/AttackonPearlHarbor_ch103",
 			"name" : "AttackonPearlHarbor_ch103",
 			"component" : ATTACKONPEARLHARBOR_CH103
 		},
 		{
 			"path" : "/AttackonPearlHarbor_ch104",
 			"name" : "AttackonPearlHarbor_ch104",
 			"component" : ATTACKONPEARLHARBOR_CH104
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js